import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RestaurantAppPreview from "../../app/RestaurantAppPreview";
import TagList from "../../utils/TagList";
import UserAvatar from "../../utils/UserAvatar";
import Alert from "../../utils/Alert";
import Checkbox from "react-custom-checkbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";

function RestaurantRegisterReview({
  form,
  setOwnerAvatar = () => {},
  setReviewDetails = () => {},
}) {
  const { t } = useTranslation();
  const [showTabletAlert, setShowTabletAlert] = useState(!form.requireTablet);
  const cityLabel = form.city?.value
    ? `${form.city.value.npa} ${form.city.value.label}`
    : "-";
  const consumptionTags = Array.isArray(form.consumptionMode)
    ? form.consumptionMode.map((mode) => mode.value)
    : [];

  useEffect(() => {
    if (!form.requireTablet) setShowTabletAlert(true);
  }, [form.requireTablet]);

  const handleTabletRequestChange = (event) => {
    setReviewDetails({ requireTablet: event.target.checked });
    setShowTabletAlert(true);
  };

  return (
    <div className="register-review">
      {showTabletAlert && (
        <Alert variant="pastel-info" className="register-review-tablet-alert">
          <div className="bold mb-1">{t("register.step2.tablet.label")}</div>
          <div>
            {t("register.stepReview.tabletNoteText", {
              defaultValue:
                "A tablet is mandatory to use Offood during service. You can use your own tablet or ask Offood to provide one.",
            })}
          </div>
          <div className="mt-2">
            <Checkbox
              className="border-dark bg-pastel-light"
              icon={
                <div>
                  <FontAwesomeIcon
                    icon={faCheck}
                    size="sm"
                    className="text-dark"
                  />
                </div>
              }
              label={t("register.step2.tablet.with")}
              checked={Boolean(form.requireTablet)}
              onChange={(checked) =>
                handleTabletRequestChange({ target: { checked } })
              }
            />
          </div>
        </Alert>
      )}

      <div className="register-review-grid">
        <section className="register-review-card">
          <div className="register-review-card-header">
            <h4>{t("register.step2.title")}</h4>
          </div>
          <div className="register-review-restaurant">
            <RestaurantAppPreview
              size="220"
              title={form.name}
              restaurantType={form.restaurantType?.value}
              img={form.image}
            />
            {consumptionTags.length > 0 && (
              <TagList tags={consumptionTags} tKey="utils.consumptionmode." />
            )}
            <div className="register-review-row">
              <span>{t("register.step2.name.label")}</span>
              <strong>{form.name || "-"}</strong>
            </div>
            <div className="register-review-row">
              <span>{t("register.step2.category.label")}</span>
              <strong>{form.restaurantType?.label || "-"}</strong>
            </div>
            <div className="register-review-row">
              <span>{t("register.step2.address.label")}</span>
              <strong>{form.address || "-"}</strong>
            </div>
            <div className="register-review-row">
              <span>{t("register.step2.city.label")}</span>
              <strong>{cityLabel}</strong>
            </div>
            <div className="register-review-row">
              <span>{t("register.step6.email.label")}</span>
              <strong>{form.email || "-"}</strong>
            </div>
          </div>
        </section>

        <section className="register-review-card">
          <div className="register-review-card-header">
            <h4>{t("register.stepReview.restaurant.managerInfo")}</h4>
          </div>
          <div className="register-review-manager">
            <UserAvatar
              src={form.ownerImage}
              fetchRandomAvatar={
                !form.ownerImage &&
                ((avatar) => {
                  setOwnerAvatar(avatar);
                })
              }
            />
            <div className="register-review-manager-info">
              <div className="register-review-manager-name">
                {form.firstname || "-"} {form.lastname || ""}
              </div>
              <div className="register-review-manager-role">
                {form.function || "-"}
              </div>
              <div className="register-review-row">
                <span>{t("register.step4.phone.label")}</span>
                <strong>{form.phone || "-"}</strong>
              </div>
              <div className="register-review-row">
                <span>{t("register.step6.email.label")}</span>
                <strong>{form.email || "-"}</strong>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default RestaurantRegisterReview;
